import { MessageCircle } from "lucide-react";
import { buildWhatsAppUrl } from "@/utilities/whatsapp";
import { trackEvent, AnalyticsEvents } from "@/utilities/analytics";

export default function WhatsAppButton({
    message,
    label = "WhatsApp Enquiry",
    source = "cta",
    variant = "primary",
    className = "",
    testId = "whatsapp-cta-btn",
}) {
    const href = buildWhatsAppUrl(message);
    const cls =
        variant === "whatsapp"
            ? "cs-btn-whatsapp"
            : variant === "outline"
              ? "cs-btn-outline-dark"
              : variant === "ghost"
                ? "cs-btn-ghost"
                : "cs-btn-primary";
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className={`${cls} ${className}`}
            onClick={() => trackEvent(AnalyticsEvents.WHATSAPP_CLICK, { source })}
            data-testid={testId}
        >
            <MessageCircle size={16} strokeWidth={2} />
            {label}
        </a>
    );
}
